import { SET_STATE, START_TIMER, STOP_TIMER } from "./actions";

export default function domainsReducer(
	state = {
		is_running: false,
		end_timestamp: false,
		minutes_remaining: 45,
		countdown: {
			is_showing: false,
			current_message: "",
		},
	},
	action
) {
	switch (action.type) {
		case SET_STATE:
			return Object.assign({}, state, action.timer_state);

		// Starting and stopping are only used to improve smoothness of UI
		// feedback. The background script is considered the source of truth
		// for timer state, but async requests through chrome cause lag. These
		// redux-actions just ensure the UI appears responsive.
		case START_TIMER:
			return Object.assign({}, state, {
				is_running: true,
				minutes_remaining: action.timer_duration,
			});
		case STOP_TIMER:
			return Object.assign({}, state, { is_running: false });

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ../shared/store/timer/reducer.js